
import React, { useState } from "react";

const InvoiceModal = ({
  showInvoiceModal,
  setShowInvoiceModal,
  invoiceDetails,
  handleInvoiceChange,
  submitInvoice,
  units,
}) => {
  const [errors, setErrors] = useState({});
  
  if (!showInvoiceModal) return null;

  const validateForm = () => {
    const newErrors = {};
    
    if (!invoiceDetails.quantity || invoiceDetails.quantity <= 0) {
      newErrors.quantity = "الكمية مطلوبة ويجب أن تكون أكبر من الصفر";
    }
    
    if (!invoiceDetails.amount || invoiceDetails.amount <= 0) {
      newErrors.amount = "السعر الكلي مطلوب ويجب أن يكون أكبر من الصفر";
    }
    
    if (!invoiceDetails.dueDate) {
      newErrors.dueDate = "تاريخ التسليم مطلوب";
    }
    
    if (!invoiceDetails.deliveryPlace) {
      newErrors.deliveryPlace = "مكان التسليم مطلوب";
    }
    
    if (!invoiceDetails.unitId) {
      newErrors.unitId = "الوحدة مطلوبة";
    }
    
    if (!invoiceDetails.paymentTerms) {
      newErrors.paymentTerms = "شروط الدفع مطلوبة";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      submitInvoice();
    }
  };

  return (
    <div dir="rtl" className="fixed top-0 left-0 z-[10000] w-full h-full bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-[800px] max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">إصدار فاتورة</h2>

        {/* Grid Container */}
        <div className="grid grid-cols-2 gap-4">
          {/* Quantity */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">الكمية</label>
            <input
              type="number"
              name="quantity"
              value={invoiceDetails.quantity}
              onChange={handleInvoiceChange}
              placeholder="الكمية"
              className={`w-full border p-2 rounded ${errors.quantity ? 'border-red-500' : ''}`}
              min="1"
            />
            {errors.quantity && <p className="text-red-500 text-sm mt-1">{errors.quantity}</p>}
          </div>

          {/* Total Price */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">إجمالي السعر (بالجنيه)</label>
            <input
              type="number"
              name="amount"
              value={invoiceDetails.amount}
              onChange={handleInvoiceChange}
              placeholder="السعر الكلي"
              className={`w-full border p-2 rounded ${errors.amount ? 'border-red-500' : ''}`}
              min="1"
            />
            {errors.amount && <p className="text-red-500 text-sm mt-1">{errors.amount}</p>}
          </div>

          {/* Delivery Date */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">تاريخ التسليم</label>
            <input
              type="date"
              name="dueDate"
              value={invoiceDetails.dueDate}
              onChange={handleInvoiceChange}
              className={`w-full border p-2 rounded ${errors.dueDate ? 'border-red-500' : ''}`}
              min={new Date().toISOString().split("T")[0]}
              max={new Date(new Date().setMonth(new Date().getMonth() + 3))
                .toISOString()
                .split("T")[0]}
            />
            {errors.dueDate && <p className="text-red-500 text-sm mt-1">{errors.dueDate}</p>}
          </div>

          {/* Delivery Place */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">مكان التسليم</label>
            <input
              type="text"
              name="deliveryPlace"
              value={invoiceDetails.deliveryPlace}
              onChange={handleInvoiceChange}
              placeholder="مكان التسليم"
              className={`w-full border p-2 rounded ${errors.deliveryPlace ? 'border-red-500' : ''}`}
            />
            {errors.deliveryPlace && <p className="text-red-500 text-sm mt-1">{errors.deliveryPlace}</p>}
          </div>

          {/* Unit */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">الوحدة</label>
            <select
              name="unitId"
              value={invoiceDetails.unitId}
              onChange={handleInvoiceChange}
              className={`w-full border p-2 rounded ${errors.unitId ? 'border-red-500' : ''}`}
            >
              <option value="">اختر الوحدة</option>
              {units.map((unit) => (
                <option key={unit.id} value={unit.id}>
                  {unit.name}
                </option>
              ))}
            </select>
            {errors.unitId && <p className="text-red-500 text-sm mt-1">{errors.unitId}</p>}
          </div>

          {/* Delivery Responsibility */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">مسؤولية التسليم</label>
            <select
              name="deliveryResponsibility"
              value={invoiceDetails.deliveryResponsibility}
              onChange={handleInvoiceChange}
              className="w-full border p-2 rounded"
            >
              <option value="seller">البائع</option>
              <option value="buyer">المشتري</option>
            </select>
          </div>

          {/* Payment Terms */}
          <div className="col-span-2">
            <label className="block text-gray-700 font-medium mb-1">شروط الدفع</label>
            <textarea
              name="paymentTerms"
              value={invoiceDetails.paymentTerms}
              onChange={handleInvoiceChange}
              placeholder="شروط الدفع"
              className={`w-full border p-2 rounded ${errors.paymentTerms ? 'border-red-500' : ''}`}
              rows="3"
            ></textarea>
            {errors.paymentTerms && <p className="text-red-500 text-sm mt-1">{errors.paymentTerms}</p>}
          </div>

          {/* Notes */}
          <div className="col-span-2">
            <label className="block text-gray-700 font-medium mb-1">الملاحظات (اختياري)</label>
            <textarea
              name="notes"
              value={invoiceDetails.notes}
              onChange={handleInvoiceChange}
              placeholder="أضف ملاحظات هنا..."
              className="w-full border p-2 rounded"
              rows="3"
            ></textarea>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-6 flex gap-4">
          <button
            className="bg-primary text-white p-2 w-full rounded-lg"
            onClick={handleSubmit}
          >
            إصدار الفاتورة
          </button>
          <button
            className="bg-red-500 text-white p-2 w-full rounded-lg"
            onClick={() => {
              setErrors({});
              setShowInvoiceModal(false);
            }}
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceModal;